module.exports = __webpack_public_path__ + "img/face.8f9ec596.png";